export default "__VITE_ASSET__C6EG9fwQ__"